/**
 * @generated SignedSource<<ae30d4483b84747370af3d046f8af751>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BetaNavigationAudience = "SITE_ADMIN" | "TEACHER" | "%future added value";
export type BetaNavigationVideoUrlQuery$variables = {
  audience: BetaNavigationAudience;
};
export type BetaNavigationVideoUrlQuery$data = {
  readonly betaNavigationVideoUrl: string | null | undefined;
};
export type BetaNavigationVideoUrlQuery = {
  response: BetaNavigationVideoUrlQuery$data;
  variables: BetaNavigationVideoUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "audience"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "audience",
        "variableName": "audience"
      }
    ],
    "kind": "ScalarField",
    "name": "betaNavigationVideoUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BetaNavigationVideoUrlQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BetaNavigationVideoUrlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c78c647daacde462f1dd13b981bc969",
    "id": null,
    "metadata": {},
    "name": "BetaNavigationVideoUrlQuery",
    "operationKind": "query",
    "text": "query BetaNavigationVideoUrlQuery(\n  $audience: BetaNavigationAudience!\n) {\n  betaNavigationVideoUrl(audience: $audience)\n}\n"
  }
};
})();

(node as any).hash = "cefa09a35b6ab72ff079d7f95e252541";

export default node;
